import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const FilterIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.5 4.5C9.67157 4.5 9 5.17157 9 6C9 6.82843 9.67157 7.5 10.5 7.5C11.3284 7.5 12 6.82843 12 6C12 5.17157 11.3284 4.5 10.5 4.5ZM7 6C7 4.067 8.567 2.5 10.5 2.5C12.0855 2.5 13.4248 3.55426 13.8551 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H13.8551C13.4248 8.44574 12.0855 9.5 10.5 9.5C8.567 9.5 7 7.933 7 6ZM2 6C2 5.44772 2.44772 5 3 5H4C4.55228 5 5 5.44772 5 6C5 6.55228 4.55228 7 4 7H3C2.44772 7 2 6.55228 2 6ZM16.5 10.5C15.6716 10.5 15 11.1716 15 12C15 12.8284 15.6716 13.5 16.5 13.5C17.3284 13.5 18 12.8284 18 12C18 11.1716 17.3284 10.5 16.5 10.5ZM13 12C13 10.067 14.567 8.5 16.5 8.5C18.0892 8.5 19.431 9.55912 19.858 11.01C19.9044 11.0034 19.9518 11 20 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H20C19.9518 13 19.9044 12.9966 19.858 12.99C19.431 14.4409 18.0892 15.5 16.5 15.5C14.567 15.5 13 13.933 13 12ZM2 12C2 11.4477 2.44772 11 3 11H10C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H3C2.44772 13 2 12.5523 2 12ZM7.5 16.5C6.67157 16.5 6 17.1716 6 18C6 18.8284 6.67157 19.5 7.5 19.5C8.32843 19.5 9 18.8284 9 18C9 17.1716 8.32843 16.5 7.5 16.5ZM4.14494 17C4.57521 15.5543 5.91449 14.5 7.5 14.5C9.433 14.5 11 16.067 11 18C11 19.933 9.433 21.5 7.5 21.5C5.91449 21.5 4.57521 20.4457 4.14494 19H3C2.44772 19 2 18.5523 2 18C2 17.4477 2.44772 17 3 17H4.14494ZM13 18C13 17.4477 13.4477 17 14 17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H14C13.4477 19 13 18.5523 13 18Z'
        fill={color}
      />
    </svg>
  )
})
